/** 管理端用户下拉展示（接口字段 real_name 来自 fangdong_ext / zuke_ext / 银行卡开户名兜底） */
export function formatAdminUserSelectLabel(u) {
  if (!u) return '';
  const real = String(u.real_name || '').trim();
  const nick = String(u.nickname || '').trim() || '未命名';
  const phone = String(u.phone || '').trim() || '无';
  if (real) {
    return `姓名:${real} | 昵称:${nick}（ID:${u.id} 手机:${phone}）`;
  }
  return `${nick}（ID:${u.id} 手机:${phone}）`;
}
